import withAPIAction from 'helpers/withAPIAction'
import {
  MerchantInitReq,
  MerchantCreatePackageReq,
  StaffListReq,
  CreateStaffReq,
  StaffRolesReq,
  StaffDetailReq,
  UpdateStaffReq,
  DeleteStaffReq,
  ResetPinReq,
  MerchantPackageListReq,
  PackagesSpecReq,
  PackagesSpecByIDReq,
  PackagesRegisReq,
  ActivateReq,
  StaffStatusReq,
  PackageLogReq,
  CheckPackageReq,
  GetConfigReq,
  SetConfigReq,
  GetConfigListReq,
  PaymentConfigReq,
  GetPaymentConfigReq,
} from './types'
import {
  getMerchantInitAction,
  MerchantCreatePackageAction,
  getStaffListAction,
  createAction,
  getRolesListAction,
  getDetailAction,
  updateAction,
  deleteAction,
  resetPinAction,
  getMerchantPackageListAction,
  getPackagesSpecAction,
  getPackagesSpecByIDAction,
  buyPackageAction,
  renewPackageAction,
  activatePackageAction,
  updateStaffStatusAction,
  getPackagesLogAction,
  checkMerchantPackageAction,
  getConfigAction,
  setConfigAction,
  getConfigListAction,
  setPaymentConfigAction,
  getPaymentConfigListAction,
} from './actions'
import { APIPath } from 'services/APIPath'
import { appConfig } from 'config'
import { getRequestString } from 'helpers/format'
import { DocumentConfigKey } from 'helpers/constanst'

export const merchantPackageInitAPI = (data: MerchantInitReq, token: string, xmid: any) => {
  return withAPIAction<MerchantInitReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.posMerchantPackage,
    data,
    token,
    xmid,
  })(getMerchantInitAction)
}

export const merchantCreatePackageAPI = (data: MerchantCreatePackageReq, token: string, xmid: any) => {
  return withAPIAction<MerchantCreatePackageReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.posMerchantPackage,
    data,
    token,
    xmid,
  })(MerchantCreatePackageAction)
}

export const staffListAPI = (data: StaffListReq, token: string, xmid: any) => {
  return withAPIAction<StaffListReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    // path: APIPath.posGetStaffList,
    path: `${APIPath.posGetStaffList}?${getRequestString(data)}`,
    data,
    token,
    xmid,
  })(getStaffListAction)
}

export const createStaffAPI = (data: CreateStaffReq, token: string, xmid: any) => {
  return withAPIAction<CreateStaffReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.posCreateStaff,
    data,
    token,
    xmid,
  })(createAction)
}

export const getRolesAPI = (data: StaffRolesReq, token: string, xmid: any) => {
  return withAPIAction<StaffRolesReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.posGetStaffRoles,
    data,
    token,
    xmid,
  })(getRolesListAction)
}

export const staffDetailAPI = (data: StaffDetailReq, token: string, xmid: any) => {
  const endPoint = APIPath.posGetStaffByID.replace(':id', data.id.toString())
  return withAPIAction<StaffDetailReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
    xmid,
  })(getDetailAction)
}

export const updateStaffAPI = (data: UpdateStaffReq, token: string, xmid: any) => {
  const endPoint = APIPath.posUpdateStaff.replace(':id', data.id.toString())
  return withAPIAction<UpdateStaffReq>({
    method: 'PUT',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
    xmid,
  })(updateAction)
}

export const deleteStaffAPI = (data: DeleteStaffReq, token: string, xmid: any) => {
  const endPoint = APIPath.posDeleteStaff.replace(':id', data.id.toString())
  return withAPIAction<DeleteStaffReq>({
    method: 'DELETE',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
    xmid,
  })(deleteAction)
}

export const updateStaffStatusAPI = (data: StaffStatusReq, token: string, xmid: any) => {
  const endPoint = APIPath.posUpdateStaffStaus.replace(':id', data.id.toString())
  return withAPIAction<StaffStatusReq>({
    method: 'PUT',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
    xmid,
  })(updateStaffStatusAction)
}

export const resetStaffPinAPI = (data: ResetPinReq, token: string, xmid: any) => {
  const endPoint = APIPath.posResetStaffPin.replace(':id', data.id.toString())
  return withAPIAction<ResetPinReq>({
    method: 'PUT',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
    xmid,
  })(resetPinAction)
}

export const getMerchantPackageListAPI = (data: MerchantPackageListReq, token: string, xmid: any) => {
  return withAPIAction<MerchantPackageListReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.posMerchantPackageList,
    data,
    token,
    xmid,
  })(getMerchantPackageListAction)
}

export const getPackagesSpecAPI = (data: PackagesSpecReq, token: string, xmid: any) => {
  return withAPIAction<PackagesSpecReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.posPackageSpec,
    data,
    token,
    xmid,
  })(getPackagesSpecAction)
}

export const packageSpecByIDAPI = (data: PackagesSpecByIDReq, token: string, xmid: any) => {
  const endPoint = APIPath.posPackageSpecByID.replace(':id', data.id.toString())
  return withAPIAction<PackagesSpecByIDReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
    xmid,
  })(getPackagesSpecByIDAction)
}

export const buyPackageAPI = (data: PackagesRegisReq, token: string, xmid: any) => {
  return withAPIAction<PackagesRegisReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.posBuyPackage,
    data,
    token,
    xmid,
  })(buyPackageAction)
}

export const renewPackageAPI = (data: PackagesRegisReq, token: string, xmid: any) => {
  return withAPIAction<PackagesRegisReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.posRenewPackage,
    data,
    token,
    xmid,
  })(renewPackageAction)
}

export const activatePackageAPI = (data: ActivateReq, token: string, xmid: any) => {
  const endPoint = APIPath.posActivatePackage.replace(':id', data.id.toString())
  return withAPIAction<ActivateReq>({
    method: 'PUT',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
    xmid,
  })(activatePackageAction)
}

export const getPackageLogsAPI = (data: PackageLogReq, token: string, xmid: any) => {
  const endPoint = APIPath.posPackageLog.replace(':id', data.id.toString())
  return withAPIAction<PackageLogReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${endPoint}?${getRequestString(data)}`,
    data,
    token,
    xmid,
  })(getPackagesLogAction)
}

export const checkMerchantPackagesAPI = (data: CheckPackageReq, token: string) => {
  return withAPIAction<CheckPackageReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.checkMerchantPackage,
    data,
    token,
  })(checkMerchantPackageAction)
}

export const getConfigAPI = (data: GetConfigReq, token: string, xmid: any) => {
  return withAPIAction<GetConfigReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.getMerchantConfig}?${getRequestString(data)}`,
    data,
    token,
    xmid,
  })(getConfigAction)
}

export const setConfigAPI = (data: SetConfigReq, token: string, xmid: any) => {
  return withAPIAction<SetConfigReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.setMerchantConfig,
    data,
    token,
    xmid,
  })(setConfigAction)
}

export const getConfigListAPI = (data: GetConfigListReq, token: string, xmid: any) => {
  return withAPIAction<GetConfigListReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.getMerchantConfigList}?${getRequestString(data)}`,
    data,
    token,
    xmid,
  })(getConfigListAction)
}

export const setPaymentConfigAPI = (data: PaymentConfigReq, token: string, xmid: any) => {
  return withAPIAction<PaymentConfigReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.setPaymentConfig,
    data,
    token,
    xmid,
  })(setPaymentConfigAction)
}

export const getPaymentConfigListAPI = (data: GetPaymentConfigReq, token: string, xmid: any) => {
  return withAPIAction<GetPaymentConfigReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.getPaymentConfigList}?${getRequestString(data)}`,
    data,
    token,
    xmid,
  })(getPaymentConfigListAction)
}
